import { Link } from "react-router-dom";

const footerColumns = [
  {
    title: "影视分类",
    links: [
      { label: "电影", to: "/category/movie" },
      { label: "电视剧", to: "/category/tv" },
      { label: "明星动态", to: "/star-news" },
      { label: "精选专题", to: "/special/sp-01" },
    ],
  },
  {
    title: "发现内容",
    links: [
      { label: "搜索内容", to: "/search" },
      { label: "悬疑叙事专场", to: "/special/sp-01" },
      { label: "城市与人的故事", to: "/special/sp-02" },
      { label: "治愈系影像清单", to: "/special/sp-04" },
    ],
  },
  {
    title: "关于蜜桃",
    links: [
      { label: "关于我们", to: "/about" },
      { label: "网站定位", to: "/about" },
      { label: "意见反馈", to: "/about" },
      { label: "联系方式", to: "/about" },
    ],
  },
];

export default function SiteFooter() {
  const year = new Date().getFullYear();
  return (
    <footer className="mt-16 border-t border-background-200 bg-secondary-100 text-foreground-800">
      <div className="mx-auto grid w-full max-w-[1280px] grid-cols-1 gap-8 px-4 py-12 md:px-6 lg:grid-cols-5">
        <div className="lg:col-span-2">
          <Link to="/" className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-movie-2-line text-lg"></i>
            </span>
            <span className="font-heading text-lg font-black tracking-tight text-foreground-950">
              蜜桃传媒
            </span>
          </Link>
          <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
            蜜桃传媒是专业的影视内容与传媒资讯平台，为您汇集电影、电视剧、明星动态与热点专题，助您轻松掌握娱乐传媒世界。
          </p>
        </div>

        {footerColumns.map((column) => (
          <div key={column.title}>
            <h4 className="text-sm font-bold text-foreground-950">
              <Link to="/about" className="hover:text-primary-700">
                {column.title}
              </Link>
            </h4>
            <ul className="mt-4 space-y-2.5">
              {column.links.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    className="text-sm text-foreground-600 transition-colors hover:text-primary-700"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="border-t border-secondary-200">
        <div className="mx-auto flex w-full max-w-[1280px] flex-col gap-3 px-4 py-5 text-xs text-foreground-500 sm:flex-row sm:items-center sm:justify-between md:px-6">
          <p>© {year} 蜜桃传媒 Peach Media. 本站内容均为演示示例，仅供浏览参考。</p>
          <div className="flex flex-wrap items-center gap-4">
            <span>友情链接：</span>
            <Link to="/category/movie" className="hover:text-primary-700">
              影视资讯聚合
            </Link>
            <Link to="/category/tv" className="hover:text-primary-700">
              热播剧集
            </Link>
            <Link to="/star-news" className="hover:text-primary-700">
              明星动态
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}